import { b as i, l as isVue2, r as re, T, n as ne } from './OrAutocompleteV3-8c6de221.js';
import { defineComponent, ref, computed, resolveComponent, openBlock, createElementBlock, normalizeClass, renderSlot, Fragment, createVNode, withModifiers, createCommentVNode, createElementVNode, toRef, watch, renderList, createBlock, withCtx, toDisplayString, createTextVNode } from 'vue';
import { useScroll } from '@vueuse/core';
import { OrIconButtonV3 as script$2 } from './or-icon-button-v3/index.js';
import { OrIconV3 as script$3 } from './or-icon-v3/index.js';
import { OrMenuV3 as script$4 } from './or-menu-v3/index.js';
import { OrMenuItemV3 as script$5 } from './or-menu-item-v3/index.js';

const a = (t, r) => {
  const e = r.find((n) => t === n.value);
  if (i(e))
    throw new Error("[getItemByValue]: Item not found.");
  return e;
}, m = (t, r) => t.map((e) => a(e, r)), l = async (t, r) => r.filter((e) => new RegExp(t, "i").test(e.label));

const EditorTabsItem = [
// Layout
'layout-row',
// Interactivity
'interactivity-click',
// Box
'md:max-w-[240px]',
// Spacing
'px-md', 'py-sm', 'gap-sm',
// Typography
'typography-caption-regular',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark',
// Theme (hover)
'hover:theme-foreground-primary', 'dark:hover:theme-foreground-primary-dark',
// Theme (selected)
'selected:theme-foreground-primary', 'dark:selected:theme-foreground-primary-dark', 'selected:theme-background-surface-1', 'dark:selected:theme-background-surface-1-dark'];

var script$1 = defineComponent({
  name: 'OrEditorTabsItem',
  components: {
    OrIconButton: script$2
  },
  props: {
    closeButton: {
      type: Boolean,
      default: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-editor-tabs-item-v3', ...EditorTabsItem]);
    return {
      root,
      rootStyles,
      isVue2
    };
  }
});

const _hoisted_1$1 = ["selected", "disabled"];
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("div", {
  class: /*#__PURE__*/normalizeClass(['grow'])
}, null, -1 /* HOISTED */);
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconButton = resolveComponent("OrIconButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    selected: _ctx.selected,
    disabled: _ctx.disabled,
    onClick: _cache[1] || (_cache[1] = $event => _ctx.isVue2 && _ctx.$emit('click', $event))
  }, [renderSlot(_ctx.$slots, "default"), _ctx.closeButton ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [_hoisted_2$1, createVNode(_component_OrIconButton, {
    icon: 'close',
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.$emit('close'), ["stop"]))
  }, null, 8 /* PROPS */, ["disabled"])], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true)], 10 /* CLASS, PROPS */, _hoisted_1$1);
}

script$1.render = render$1;
script$1.__file = "src/components/or-editor-tabs-v3/partials/or-editor-tabs-item/OrEditorTabsItem.vue";

var EditorTabsOverflow;
(function (EditorTabsOverflow) {
  EditorTabsOverflow["Scroll"] = "scroll";
  EditorTabsOverflow["Wrap"] = "wrap";
})(EditorTabsOverflow || (EditorTabsOverflow = {}));

const EditorTabs = [
// Layout
'layout-column'];
const EditorTabsHeader = [
// Layout
'layout-row',
// Theme
'theme-border-outline-variant border-b-1', 'dark:theme-border-outline-variant-dark', 'theme-divider-outline-variant', 'dark:theme-divider-outline-variant-dark'];
const EditorTabsHeaderTabs = [
// Layout
'layout-row grow md:grow-0',
// Box
'max-w-full',
// Theme
'theme-divider-outline-variant', 'dark:theme-divider-outline-variant-dark'];
const EditorTabsHeaderTabsOverflows = {
  [EditorTabsOverflow.Scroll]: [
  // Overflow
  'overflow-x-auto scrollbar-hidden'],
  [EditorTabsOverflow.Wrap]: [
  // Layout
  'flex-wrap']
};
const EditorTabsContent = [
// Spacing
'px-md', 'py-md',
// Box
'grow',
// Theme
'theme-background-surface-1', 'dark:theme-background-surface-1-dark'];

var script = defineComponent({
  name: 'OrEditorTabs',
  components: {
    OrEditorTabsItem: script$1,
    OrIcon: script$3,
    OrMenu: script$4,
    OrMenuItem: script$5
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: undefined,
      default: undefined
    },
    items: {
      type: Array,
      required: true
    },
    overflow: {
      type: String,
      default: () => EditorTabsOverflow.Scroll
    },
    addButton: {
      type: Boolean,
      default: true
    },
    closeButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'open', 'close'],
  expose: ['root'],
  setup(props, context) {
    // Refs
    const root = ref();
    const headerTabs = ref();
    const editorTabsItems = ref();
    // Styles
    const rootStyles = computed(() => ['or-editor-tabs-v3', ...EditorTabs]);
    const headerStyles = computed(() => [...EditorTabsHeader]);
    const headerTabsStyles = computed(() => [...EditorTabsHeaderTabs, ...EditorTabsHeaderTabsOverflows[props.overflow]]);
    const contentStyles = computed(() => [...EditorTabsContent]);
    // State
    const proxyModelValue = re(toRef(props, 'modelValue'), context.emit);
    const selectedItem = computed(() => {
      return !T(proxyModelValue.value) ? a(proxyModelValue.value, props.items) : undefined;
    });
    watch(selectedItem, value => {
      var _a, _b, _c;
      if (value) {
        (_c = (_b = (_a = editorTabsItems.value) === null || _a === void 0 ? void 0 : _a[props.items.indexOf(value)]) === null || _b === void 0 ? void 0 : _b.root) === null || _c === void 0 ? void 0 : _c.scrollIntoView();
      }
    }, {
      flush: 'post'
    });
    const overflowItems = computed(() => {
      return props.items.filter(item => item.value !== proxyModelValue.value);
    });
    const showOverflowMenu = ref(false);
    const {
      x: headerTabsScroll
    } = useScroll(headerTabs);
    // Handlers
    function onWheel(event) {
      headerTabsScroll.value = headerTabsScroll.value + event.deltaY;
    }
    // Methods
    function open() {
      context.emit('open');
    }
    function close(item) {
      if (item.value === proxyModelValue.value) {
        const index = props.items.indexOf(item);
        if (index !== -1) {
          const nextItem = props.items[index + 1];
          const previousItem = props.items[index - 1];
          proxyModelValue.value = (nextItem === null || nextItem === void 0 ? void 0 : nextItem.value) || (previousItem === null || previousItem === void 0 ? void 0 : previousItem.value);
        }
      }
      context.emit('close', item);
    }
    // Helpers
    const {
      isDesktop,
      isMobile
    } = ne();
    // Effects
    watch(() => props.items, items => {
      if (items.length === 1) {
        proxyModelValue.value = items[0].value;
      }
    }, {
      immediate: true
    });
    return {
      root,
      headerTabs,
      editorTabsItems,
      rootStyles,
      headerStyles,
      headerTabsStyles,
      contentStyles,
      proxyModelValue,
      selectedItem,
      overflowItems,
      showOverflowMenu,
      onWheel,
      open,
      close,
      isDesktop,
      isMobile
    };
  }
});

const _hoisted_1 = {
  class: /*#__PURE__*/normalizeClass(['truncate'])
};
const _hoisted_2 = {
  class: /*#__PURE__*/normalizeClass(['truncate'])
};
const _hoisted_3 = {
  class: /*#__PURE__*/normalizeClass(['layout-row', 'gap-sm'])
};
const _hoisted_4 = {
  class: /*#__PURE__*/normalizeClass(['truncate'])
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrEditorTabsItem = resolveComponent("OrEditorTabsItem");
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrMenuItem = resolveComponent("OrMenuItem");
  const _component_OrMenu = resolveComponent("OrMenu");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.headerStyles)
  }, [createElementVNode("div", {
    ref: 'headerTabs',
    class: normalizeClass(_ctx.headerTabsStyles),
    onWheel: _cache[1] || (_cache[1] = withModifiers($event => _ctx.onWheel($event), ["prevent"]))
  }, [_ctx.isDesktop ? (openBlock(true), createElementBlock(Fragment, {
    key: 0
  }, renderList(_ctx.items, item => {
    return openBlock(), createBlock(_component_OrEditorTabsItem, {
      ref_for: true,
      ref: 'editorTabsItems',
      key: item.value,
      "close-button": _ctx.closeButton && !item.pinned,
      selected: item.value === _ctx.proxyModelValue,
      disabled: item.disabled,
      onClick: $event => _ctx.proxyModelValue = item.value,
      onClose: $event => _ctx.close(item)
    }, {
      default: withCtx(() => [renderSlot(_ctx.$slots, `${item.value}-label`, {
        label: item.label
      }, () => [createElementVNode("div", _hoisted_1, toDisplayString(item.label), 1 /* TEXT */)])]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["close-button", "selected", "disabled", "onClick", "onClose"]);
  }), 128 /* KEYED_FRAGMENT */)) : createCommentVNode("v-if", true), _ctx.isMobile && _ctx.selectedItem ? (openBlock(), createBlock(_component_OrEditorTabsItem, {
    key: 1,
    class: normalizeClass(['grow']),
    "close-button": _ctx.closeButton && !_ctx.selectedItem.pinned,
    selected: true,
    disabled: _ctx.selectedItem.disabled,
    onClose: _cache[0] || (_cache[0] = $event => _ctx.close(_ctx.selectedItem))
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, `${_ctx.selectedItem.value}-label`, {
      label: _ctx.selectedItem.label
    }, () => [createElementVNode("div", _hoisted_2, toDisplayString(_ctx.selectedItem.label), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["close-button", "disabled"])) : createCommentVNode("v-if", true)], 34 /* CLASS, NEED_HYDRATION */), _ctx.addButton ? (openBlock(), createBlock(_component_OrEditorTabsItem, {
    key: 0,
    "close-button": false,
    onClick: _cache[2] || (_cache[2] = $event => _ctx.open())
  }, {
    default: withCtx(() => [createVNode(_component_OrIcon, {
      icon: 'add',
      size: 'm'
    })]),
    _: 1 /* STABLE */
  })) : createCommentVNode("v-if", true), _ctx.isMobile && _ctx.items.length > 1 ? (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [createVNode(_component_OrEditorTabsItem, {
    "close-button": false,
    onClick: _cache[3] || (_cache[3] = $event => _ctx.showOverflowMenu = true)
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.overflowItems.length) + " ", 1 /* TEXT */), createVNode(_component_OrIcon, {
      icon: 'more_vert',
      size: 'm'
    })]),
    _: 1 /* STABLE */
  }), createVNode(_component_OrMenu, {
    "is-open": _ctx.showOverflowMenu,
    onClose: _cache[4] || (_cache[4] = $event => _ctx.showOverflowMenu = false)
  }, {
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.overflowItems, item => {
      return openBlock(), createBlock(_component_OrMenuItem, {
        key: item.value,
        "close-button": _ctx.closeButton && !item.pinned,
        disabled: item.disabled,
        onClick: $event => _ctx.proxyModelValue = item.value,
        onClose: $event => _ctx.close(item)
      }, {
        default: withCtx(() => [createElementVNode("div", _hoisted_3, [renderSlot(_ctx.$slots, `${item.value}-label`, {
          label: item.label
        }, () => [createElementVNode("div", _hoisted_4, toDisplayString(item.label), 1 /* TEXT */)])])]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["close-button", "disabled", "onClick", "onClose"]);
    }), 128 /* KEYED_FRAGMENT */))]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["is-open"])], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true)], 2 /* CLASS */), createElementVNode("div", {
    class: normalizeClass(_ctx.contentStyles)
  }, [renderSlot(_ctx.$slots, _ctx.proxyModelValue)], 2 /* CLASS */)], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-editor-tabs-v3/OrEditorTabs.vue";

export { EditorTabsOverflow as E, a, l, m, script as s };
